import { createRouteContextObject } from '@shared/utils';
import { HttpContextBase } from '..';

enum HttpContextRoutes {
  GetDprDetails,
  GetDprDetailsId,
  GetPreviousDprDetailsId,
  GetNextDprDetailsId,
  CopyDprFromPrevious,
  CopySelectedActivities,
  IsFirstDpr,
  SyncDprActivities,
  SyncDprStatusTracker,
  SyncDprWeather,
  SyncDprPersonnel,
  SyncDprConsumable,
  SyncDprHse,
  SyncDprSummary,
  SyncDprForecastActivities,
  CopyDprForecastActivitiesFromPreviousDpr,
  SyncDprFreeTextField,
  SyncDprProgress,
  SyncDprProgressWithoutTarget,
  SyncDprSummaryExternalComment,
  SyncDprTableOfColumns,
  SyncDprAppendix,
  SyncDprHidden,
}

export const HttpDprDetailsContext = createRouteContextObject(
  HttpContextBase.DprDetails,
  HttpContextRoutes
);
